// https://www.cluemediator.com/detect-urls-in-a-text-and-convert-them-to-a-link-in-react#da for linkify

import { useState, useEffect } from "react"
import axios from 'axios'
import {
  // RouterProvider,
  // createBrowserRouter,
  // RouterProvider,
  // useLoaderData,
  // useLocation,
  useParams,
  useNavigate,
  // Navigate,
  // useSearchParams
} from "react-router-dom"

import {
  useForm,
  UseFormProps,
  UseFormReturn,
  FormProvider,
  SubmitHandler,
  // Controller
} from "react-hook-form";

import {
  useQuery,
  useMutation,
  // useQueryClient,
  // QueryClient,
} from '@tanstack/react-query'

import { yupResolver } from "@hookform/resolvers/yup";

// import { useAppStore } from '../store/appStore';

// import Linkify from 'linkify-react'


import { validationSchema } from "../validation";
import { Typography, Button, LinearProgress } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'

import { InitData, IAppForm } from '../lib/interfaces/models'

import { StudentForm } from "./StudentForm";
import { Guardians } from "./Guardians";
import { Subjects } from './Subjects';
import { ConsentForm } from './ConsentForm';
import { CommentForm } from './CommentForm';
import { PrevForm } from './PrevForm';
import { FamilyForm } from './FamilyForm';
import { SnackFeedback } from '../components/SnackFeedback';
// import { useEffect } from 'react';




export const AppForm = () => {
  const [showWarning, setShowWarning] = useState(false)

  const navigate = useNavigate()

  // const linkifyOptions = {
  //   target: '_blank',
  //   style: { color: '#ff0000' },
  // }

  // const hideSubmit = useAppStore(state => state.hideSubmit)
  // const setApiReturn = useAppStore(state => state.setApiReturn)
  // const setSnackText = useAppStore(state => state.setSnackText)
  // const [searchParams, setSearchParams] = useSearchParams()
  // needs in tsconfig.json:  "downlevelIteration": true
  // const currentParams = Object.fromEntries([...searchParams])
  const { s, c, k } = useParams()

  // const { data } = useQuery<InitData>({ queryKey: [`/appform/${s}/${c}/${k}`] })
  const { data, isLoadingError } = useQuery<InitData>({ queryKey: [`/appform3/${s}/${c}/${k}`] })

  const apiData = data?.data
  const masterTermsFlag = apiData?.form.emailFlag || apiData?.form.termsFlag || apiData?.form.mediaFlag

  const oSchoolOptions = apiData?.oschool.map(option => {
    return { title: option.name, value: option.nr }
  })

  const getScYear = () => {
    return apiData?.form.year
  }

  const mutation = useMutation({
    mutationFn: (formData: IAppForm) => {
      return axios.post('https://tonviska.is/api/v1/appform3', formData)
    }
  })




  const defaultValues = {
    terms: false,
    email: false,
    ssid: '',
    name: '',
    email1: '',
    email2: '',
    email3: '',
    tel1: '',
    tel2: '',
    tel3: '',
    oschool: '',
    oschoolclass: '',
    prev: '',
    subjects: [
      { id: '', teacherid: '', rateid: '', gradeid: '' },
    ]
  }


  const form: UseFormReturn<IAppForm, UseFormProps> = useForm<IAppForm>({
    // mode: "all",
    // mode: "onBlur",
    // mode: "onChange",
    mode: "onTouched",
    defaultValues,
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    setShowWarning(JSON.stringify(form.formState.errors) !== '{}')
  }, [form.formState])

  if (mutation.isSuccess) {
    const postReply = mutation.data.data.data
    const retUrl = `/ret/${postReply.nr}/${postReply.code}/${postReply.applicationId}`
    navigate(retUrl, { replace: true })

  }

  const submitForm: SubmitHandler<IAppForm> = (formData: IAppForm) => {
    // const mobileFlag = formData.mobile === true ? 1 : 0
    // const tmpData = {...formData, mobile: mobileFlag}
    // console.log('data: ', tmpData)
    const dataToSend: IAppForm = { ...formData, scYear: getScYear() }
    mutation.mutate(dataToSend)
  };

  // console.log('Form state', form.formState.isValid)
  // const resetForm = () => {
  //   form.reset(defaultValues);
  // };

  // const doTest = () => {
  //   form.reset(values)
  // }
  // useEffect(() => {
  //   form.reset(values)
  // }, [])
  //  console.log('isLoading', isLoading)

  return (
    <>

      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(submitForm)}>

          <Grid container sx={{ pt: 1, backgroundColor: '#FAFAFA' }}>
            {isLoadingError &&
              <Grid xs={12}>
                <Typography>Villa kom upp !</Typography>
              </Grid>
            }
            <Grid xs={12}>
              <Typography variant='h5' align="center">{apiData?.school.name}</Typography>
            </Grid>

            {apiData?.closed
              ?
              <Grid xs={12}>
                <Typography variant='h5' align="center">Lokað er fyrir umsóknir</Typography>
              </Grid>
              :
              apiData?.school.name
                ?
                <>
                  <Grid xs={12}>
                    <Typography variant="h6" align="center">Umsókn um skólavist</Typography>
                    <Typography variant="h6" align="center">{apiData?.form.year} - {apiData?.form.year + 1}</Typography>
                  </Grid>

                  <Grid xs={12}>
                    <StudentForm
                      oSchoolOptions={oSchoolOptions || [{ title: "", value: 0 }]}
                      oschool={apiData.form.oschool}
                      oclass={apiData.form.oclass} />
                  </Grid>

                  <Grid xs={12}>
                    <Guardians />

                    {apiData.form.familyFlag === 1 && <Grid xs={12}>
                      <FamilyForm
                        title={apiData.form.familyText}
                        subtitle={apiData.form.familySubText}
                        schoolName3={apiData.school.name3}
                      />
                    </Grid>}

                    {apiData.form.prevFlag === 1 && <Grid xs={12}>
                      <PrevForm
                        title='Fyrra tónlistarnám'
                        schoolName3={apiData.school.name3}
                      />
                    </Grid>}
                  </Grid>


                  <Grid xs={12}>
                    <Subjects
                      options={apiData.subject}
                      teacherOptions={apiData.teacher}
                      teacherFlag={apiData.form.teacherFlag}
                      placeOptions={apiData.place}
                      gradeOptions={apiData.grade}
                      ratioOptions={apiData.ratio}
                      subjectMax={apiData.form.subjectMax}
                    />
                  </Grid>

                  {apiData.form.extSubjFlag === 1 && <Grid xs={12}>
                    <CommentForm
                      title={apiData.form.extSubjText}
                      name="xsubject" />
                  </Grid>}

                  {masterTermsFlag === 1 && <Grid xs={12}>
                    <ConsentForm
                      title='Skilmálar'
                      text={apiData.form.termsText}
                      name={apiData.form.termsFlag === 1 ? "terms" : ""}
                      text2={apiData.form.mediaText}
                      name2={apiData.form.mediaFlag === 1 ? "media" : ""}
                      text3={apiData.form.emailText}
                      name3={apiData.form.emailFlag === 1 ? "email" : ""}
                      text4={apiData.form.elschoolText}
                      name4={apiData.form.elschoolFlag === 1 ? "elschool" : ""}
                      text5={apiData.form.mobileText}
                      name5={apiData.form.mobileFlag === 1 ? "mobile" : ""}
                    />
                  </Grid>}

                  <Grid xs={12}>
                    <CommentForm
                      title='Annað sem þú vilt taka fram'
                      subtitle="T.d. tónlistarmenntun, reynsla í tónlist eða annað sem gæti skipt máli"
                      name="comment" />
                  </Grid>

                  {showWarning &&
                    <Grid xs={12} sx={{ textAlign: 'center', p: 2 }}>
                      <Typography color={'red'}>Fylla þarf út nauðsynlega reiti</Typography>
                    </Grid>
                  }
                  <Grid xs={12} sx={{ textAlign: 'center', p: 2 }}>
                    <Button disabled={showWarning} type="submit" variant='contained' size='small' fullWidth sx={{ maxWidth: '60%' }}>
                      Senda inn umsókn
                    </Button>
                  </Grid>
                </>
                :
                (

                  <Grid xs={12} sx={{ mt: 8 }}>
                    <Typography variant="h5" align="center">
                      <LinearProgress />
                    </Typography>
                  </Grid>
                )
            }

          </Grid>
          <br />
          <br />


          <input type="hidden" defaultValue={c} {...form.register("code")} />
          <input type="hidden" defaultValue={s} {...form.register("scNr")} />
        </form>
      </FormProvider>
      <SnackFeedback />
    </>
  );
};

export default AppForm;
